import React, { useState } from 'react';

const FileUploader = ({ existingFilesCount = 0, existingFileResponses = [], maxFiles = 5, startIndex }) => {
  const availableSlots = Math.max(0, maxFiles - existingFilesCount);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileSelect = (slotIndex, file) => {
    setUploadedFiles(prev => {
      const updated = [...prev];
      updated[slotIndex] = file;
      return updated;
    });
  };

  const usedKeys = existingFileResponses
    .map((r) => {
      if (!r || typeof r.question_key !== 'string') return NaN;
      const match = r.question_key.match(/^file_(\d+)$/);
      return match ? parseInt(match[1], 10) : NaN;
    })
    .filter((key) => Number.isInteger(key));
  const availableKeys = Array.from({ length: maxFiles }, (_, i) => i + 1).filter(k => !usedKeys.includes(k));

  const isFirstSlotRequired = existingFilesCount === 0;

  return (
    <div className='flex flex-col'>
      {availableKeys.slice(0, availableSlots).map((fileNum, idx) => {
        const hasFile = uploadedFiles[idx];

        return (
          <div key={fileNum} className='form-group'>
            <div className='flex items-center gap-x-1 text-red-700'>
              <label>Upload Image {fileNum}</label>
              {idx === 0 && isFirstSlotRequired && <span>*</span>}
            </div>
            <div className='flex flex-col'>
              <div className='pb-6'>
                <input
                  type='file'
                  name={hasFile ? `issue[responses_attributes][${startIndex + idx}][files][]` : undefined}
                  required={idx === 0 && isFirstSlotRequired}
                  onChange={(e) => handleFileSelect(idx, e.target.files?.[0])}
                />
                {hasFile && (
                  <>
                    <input type='hidden' name={`issue[responses_attributes][${startIndex + idx}][question_key]`} value={`file_${fileNum}`} />
                    <input type='hidden' name={`issue[responses_attributes][${startIndex + idx}][question_type]`} value='file' />
                    <label className='pt-4'>Image Description</label>
                    <input
                      type='text'
                      name={`issue[responses_attributes][${startIndex + idx}][value]`}
                      required
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FileUploader;
